import type { LangCode } from '@learnforge/i18n';
import { en } from './en';
import { nl } from './nl';
import { ro } from './ro';
import type { FuncKey } from './keys';

export const locales = {
  en,
  nl: nl as Record<FuncKey, string>,
  ro: ro as Record<FuncKey, string>,
} as const satisfies Partial<Record<LangCode, Record<FuncKey, string>>> & {
  en: Record<FuncKey, string>;
};
export type { FuncKey } from './keys';
